import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { ReactiveFormsModule } from "@angular/forms";
import { MatDialogModule } from "@angular/material/dialog";
import { MatIconModule } from "@angular/material/icon";
import { MatMenuModule } from "@angular/material/menu";
import { MatTooltipModule } from "@angular/material/tooltip";
import { SharedModule } from "../shared.module";
import { ISFilesUploadComponent } from "./is-files-upload.component";
import { MatSelectModule } from "@angular/material/select";

const materialModules = [
    MatIconModule,
    MatTooltipModule,
    MatDialogModule
];

@NgModule({
    declarations: [ISFilesUploadComponent],
    imports: [
        CommonModule,
        MatMenuModule,
        MatSelectModule,
        SharedModule,
        ReactiveFormsModule,
        ...materialModules
    ],
    exports: [ISFilesUploadComponent],
    providers: [],
})
export class ISFileUploadModule { }